<template>
  <div class="container-fluid pb-5 px-4">
    <div class="container-xxl">
      <div class="fs-1 py-5 fw-bold text-success">Pilihan Paket</div>
      <div v-if="!loading && pricelists.length" class="row g-4">
        <div
          v-for="(pricelist, index) in pricelists"
          :key="pricelist.id || index"
          class="col-lg-3 col-md-6"
        >
          <div class="price-card h-100">
            <!-- IMAGE -->
            <div class="price-img-wrapper">
              <!-- Featured Badge -->
              <div v-if="pricelist.is_featured" class="featured-badge">
                <i class="bi bi-star-fill me-2"></i>Populer
              </div>
              <div class="img-inner">
                <img :src="pricelist.image" class="price-img" alt="Paket" />
              </div>
            </div>

            <!-- CONTENT -->
            <div class="price-content">
              <div class="row align-items-start">
                <div class="col-7">
                  <h5 class="price-title text-start">
                    {{ pricelist.title }}
                  </h5>
                </div>
                <div class="col-5 text-end mb-2 text-bold">
                  <span class="duration-text"
                    ><i class="bi bi-stopwatch me-2 text-success"></i
                    >{{ pricelist.duration || "2-3 Jam" }}</span
                  >
                </div>
              </div>

              <!-- FACILITIES SCROLL -->
              <div class="feature-scroll text-start">
                <ul class="facility-list">
                  Include
                  <li
                    v-for="(item, i) in pricelist.facilities"
                    :key="i"
                    class="fst-italic my-2"
                  >
                    <i class="bi bi-check-circle-fill me-2"></i> {{ item }}
                  </li>
                </ul>
              </div>

              <!-- FOOTER -->
              <div class="price-footer">
                <div class="price-top">
                  <div v-if="pricelist.description" class="min-person">
                    <!-- <i class="bi bi-people-fill me-1"></i> -->
                    <i class="bi bi-person-bounding-box me-1"></i>
                    {{ pricelist.description }}
                  </div>

                  <div class="price-value">
                    IDR {{ formatPrice(pricelist.price) }}
                    <span v-if="pricelist.unit"> / {{ pricelist.unit }}</span>
                  </div>
                </div>

                <a
                  :href="whatsappLink(pricelist.title)"
                  target="_blank"
                  class="btn-book"
                  @click="trackWhatsApp(pricelist.title)"
                >
                  <i class="bi bi-whatsapp me-2"></i>
                  Booking Sekarang
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="div text-center pt-5">
        <router-link to="/price-list">
          <button class="btn btn-success fw-semibold wa-icon btn-animate-arrow">
            <span class="fw-normal">Lihat Lebih Banyak</span>
            <i class="bi bi-arrow-right-circle arrow-move ms-2"></i></button
        ></router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  setup() {
    const pricelists = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

    const fetchPriceList = async () => {
      try {
        loading.value = true;

        const response = await fetch(`${API_BASE_URL}/api/price-lists`);

        if (!response.ok) {
          throw new Error("Gagal mengambil data");
        }

        const result = await response.json();
        const data = result.data || result;

        pricelists.value = data
          .map((item) => ({
            ...item,
            facilities: item.facilities ? JSON.parse(item.facilities) : [],
          }))
          .filter((item) => item.is_featured) // hanya best seller
          .slice(0, 4); // maksimal 4 saja
      } catch (err) {
        console.error(err);
        error.value = "Terjadi kesalahan saat memuat data.";
      } finally {
        loading.value = false;
      }
    };

    const formatPrice = (price) => {
      if (!price) return "0";

      if (price >= 1000000) {
        return (price / 1000000).toFixed(price % 1000000 === 0 ? 0 : 1) + "M";
      }

      if (price >= 1000) {
        return (price / 1000).toFixed(price % 1000 === 0 ? 0 : 1) + "K";
      }

      return price;
    };

    const whatsappLink = (title) => {
      const phone = "6285802956931";
      const message = `Halo Gaharu Outbound, saya tertarik dengan paket ${title}`;
      return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    };

    const trackWhatsApp = (title) => {
      if (typeof window !== "undefined" && window.fbq) {
        window.fbq("track", "Lead", {
          content_name: title,
          content_category: "home-package-section",
          content_type: "whatsapp_click",
        });
      }
    };

    onMounted(fetchPriceList);

    return {
      pricelists,
      loading,
      error,
      formatPrice,
      whatsappLink,
      trackWhatsApp,
    };
  },
};
</script>

<style scoped>
/* HERO */
.price-hero {
  height: 300px;
  background: url("../../../assets/bg-home.webp") center/cover no-repeat;
  position: relative;
}

.title-page {
  font-size: 40px;
}

.lead-page {
  font-size: 20px;
}
/* .price-hero::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
} */

.price-hero > div {
  position: relative;
  z-index: 2;
}

/* CARD */
.price-card {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  transition: 0.4s;
  display: flex;
  flex-direction: column;
}

.price-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

/* IMAGE */
.price-img-wrapper {
  height: 250px;
  overflow: hidden;
  position: relative;
}

.img-inner {
  width: 100%;
  height: 100%;
  position: relative;
  transition: transform 0.6s ease;
}

.price-card:hover .img-inner {
  transform: scale(1.08);
}

.facility-list i {
  color: #2e8b57;
}

.price-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.img-inner {
  will-change: transform;
}

/* Gradient ikut dalam img-inner */
.img-inner::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 60%,
    #ffffff 100%
  );
}

.price-card:hover .price-img {
  transform: scale(1.08);
}

/* FEATURED */
.featured-badge {
  position: absolute;
  top: 15px;
  left: 15px;
  background: #59d506;
  color: #000000;
  padding: 5px 10px;
  font-size: 0.8rem;
  border-radius: 5px;
  font-weight: 600;
  z-index: 2;
}

/* CONTENT */
.price-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.price-title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 1.2rem;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}

.duration-text {
  font-size: 0.9rem;
}

/* FACILITY SCROLL */
.feature-scroll {
  height: 120px;
  overflow-y: auto;
  padding-right: 6px;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.feature-scroll ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-scroll li {
  font-size: 0.9rem;
  margin-bottom: 8px;
  color: #444444;
}

/* SCROLLBAR */
.feature-scroll::-webkit-scrollbar {
  width: 6px;
}

.feature-scroll::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

/* FOOTER */
.price-footer {
  margin-top: auto;
  background: linear-gradient(180deg, #f8faf8 0%, #ffffff 100%);
  padding: 15px;
  border-top: 1px solid #eeeeee;
  border-radius: 8px;
}

/* TOP PRICE AREA */
.price-top {
  text-align: center;
  margin-bottom: 12px;
}

/* MIN PERSON */

.min-person {
  font-size: 12px;
  color: #2c7f31;
  font-weight: 600;
  background: #e9f7ec;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 20px;
  margin-bottom: 6px;
}

/* PRICE */

.price-value {
  font-size: 24px;
  font-weight: 700;
  color: #111;
  letter-spacing: 0.5px;
}

.price-value span {
  font-size: 13px;
  font-weight: 500;
  color: #666;
}

/* BUTTON */

.btn-book {
  display: block;
  width: 100%;
  text-align: center;
  background: linear-gradient(90deg, #25d366, #1ebc59);
  color: white;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: 0.25s;
}

.btn-book:hover {
  transform: translateY(-3px);

  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);

  color: white;
}

.price-info {
  /* display: flex; */
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
    "Lucida Sans", Arial, sans-serif;
}

.price-info strong {
  font-size: 1.2rem;
  color: #000;
  text-align: center;
}

.price-info small {
  font-size: 0.8rem;
  color: #777;
}

.price-info span {
  font-size: 0.85rem;
  color: #777;
}

/* BUTTON */
.btn-book {
  display: block;
  text-align: center;
  background: linear-gradient(90deg, #41b83f, #2c7f31);
  color: white;
  padding: 7px;
  border-radius: 5px;
  font-weight: 400;
  text-decoration: none;
  transition: 0.3s;
  font-size: medium;
}

.btn-book:hover {
  background: #ffffff;
  transform: translateY(-3px);
  color: #2c7f31;
  box-shadow: 0 8px 20px rgba(44, 127, 49, 0.35);
  /* transform: scale(1.02); */
}

@media (max-width: 767px) {
  .price-hero {
    height: 250px;
  }
  .lead {
    font-size: medium;
  }
  .contact-hero {
    height: 200px;
    /* font-size: smaller; */
  }

  .title-page {
    /* background-color: #198754; */
    /* margin-top: 50px; */
    font-size: 25px;
  }

  .lead-page {
    font-size: 9px;
  }
  .price-title {
    font-weight: 700;
    margin-bottom: 15px;
    font-size: 1.5rem;
    font-family: "Trebuchet MS", "Lucida Sans Unicode", "Lucida Grande",
      "Lucida Sans", Arial, sans-serif;
  }
  .duration-text {
    font-size: 1rem;
  }
  .feature-scroll li {
    font-size: 1rem;
    margin-bottom: 8px;
    color: #444444;
  }
}
</style>
